"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUUID = exports.DEFAULT_PREFIX = void 0;
const uuid_1 = require("uuid");
exports.DEFAULT_PREFIX = "idPeticion";
const getUUID = (idFront = "", prefix = exports.DEFAULT_PREFIX, equalSignal = true) => {
    const v1options = {
        node: [0x01, 0x23, 0x45, 0x67, 0x89, 0xab],
        clockseq: 0x1234,
        msecs: new Date().getTime(),
        nsecs: 5678,
    };
    let uuid = (0, uuid_1.v1)(v1options);
    uuid = uuid.replace(/-/g, "");
    uuid = uuid.toUpperCase();
    const res = `${prefix}${equalSignal ? "=" : ""}${idFront}${uuid}`;
    return res;
};
exports.getUUID = getUUID;
//# sourceMappingURL=index.js.map